import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import TrackSectionMap from "./track_section_map";
import TrackSectionOrderDetails from "./track_section_order_details";
import TrackDetail from "./track_detail";
import useOrders from "./useOrder"; // Use the custom hook
import "./track_section.css";

function TrackMainSection() {
  const { orders, isLoading } = useOrders();
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleOrderSelect = (order) => {
    setSelectedOrder(order);
  };

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box sx={{ width: "100%", py: { xs: 2, sm: 3 }, px: { xs: 1, sm: 2, md: 3 }, borderRadius: "32px", background: "linear-gradient(145deg, #eeede2 0%, #f3f1e6 100%)", border: "1px solid #e2dfcf" }}>
      <Box sx={{ textAlign: "center", mb: { xs: 2.5, sm: 3.5 } }}>
        <Typography sx={{ color: "#b58519", fontSize: "0.68rem", fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase" }}>
          Stay in the loop
        </Typography>
        <Typography
          className="responsive_fontsize24"
          sx={{
            fontFamily: "Roboto Serif",
            fontWeight: 700,
            textAlign: "center",
            color: "#252920",
            letterSpacing: "-0.02em",
            mt: 0.5,
          }}
        >
          Track Your Order
        </Typography>
        <Typography sx={{ color: "#747767", mt: 0.5, fontSize: "0.9rem" }}>
          Follow every step from our kitchen to your table
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: { xs: 2, md: 3 },
          justifyContent: "center",
          alignItems: { xs: "center", md: "stretch" },
          flexDirection: { md: "row", xs: "column" },
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: { md: "52%", xs: "100%" },
            minWidth: 0,
            boxSizing: "border-box",
            maxWidth: 680,
            padding: { xs: 2, sm: 3 },
            borderRadius: "24px",
            border: "1px solid #e2dfcf",
            background: "#fffdf7",
            boxShadow: "0 12px 28px rgba(65,70,39,.08)",
            backdropFilter: "blur(8px)",
          }}
        >
          <TrackSectionOrderDetails
            orders={orders}
            onOrderSelect={handleOrderSelect}
          />
          <TrackDetail order={selectedOrder} />
        </Box>
        <Box sx={{ width: { md: "42%", xs: "100%" }, maxWidth: { xs: 680, md: 560 }, minWidth: 0, boxSizing: "border-box", display: "flex", borderRadius: "24px", overflow: "hidden", border: "1px solid #d8d7c5", boxShadow: "0 12px 28px rgba(65,70,39,.12)", background: "#fffdf7" }}>
          <TrackSectionMap />
        </Box>
      </Box>
    </Box>
  );
}

export default TrackMainSection;
